module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {}
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.currentBracket) ? _c('div', {
    staticClass: "col-sm-6",
    staticStyle: {
      "font-size": "24px",
      "color": "white"
    }
  }, [_vm._v("\r\n      " + _vm._s(_vm.currentBracket.fromTime || '00:00') + " - " + _vm._s(_vm.currentBracket.toTime || '00:00') + "\r\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6",
    staticStyle: {
      "font-size": "24px",
      "color": "white",
      "text-align": "right"
    }
  }, [_vm._v("\r\n      " + _vm._s(_vm.remainingLabel) + " "), _c('span', {
    staticStyle: {
      "color": "gold"
    }
  }, [_vm._v(_vm._s(_vm.elapsedTime))])])]), _vm._v(" "), (_vm.binList && _vm.binList.length) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "90%",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('swiper', {
    staticClass: "swiper-box",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.binList), function(bin) {
    return _c('swiper-slide', {
      staticClass: "swiper-item"
    }, [_c('div', {
      staticClass: "bin-tile"
    }, [_c('table', {
      staticStyle: {
        "width": "100%",
        "text-align": "center"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_c('h2', {
      staticStyle: {
        "padding": "0px",
        "margin": "0px"
      }
    }, [_vm._v(_vm._s(bin.name))])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [(bin.prevQty < bin.qty) ? _c('h1', {
      staticStyle: {
        "color": "maroon"
      }
    }, [_vm._v(_vm._s(bin.prevQty))]) : _c('h1', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(_vm._s(bin.prevQty))])]), _vm._v(" "), _c('td', [_c('h1', {
      staticStyle: {
        "font-size": "70px",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(bin.qty))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [(bin.nextQty < bin.qty) ? _c('h1', {
      staticStyle: {
        "color": "maroon"
      }
    }, [_vm._v(_vm._s(bin.nextQty))]) : _c('h1', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(_vm._s(bin.nextQty))])])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "position": "fixed",
      "bottom": "0px",
      "width": "100%"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td'), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "40px"
    }
  }, [_c('button', {
    staticClass: "btn btn-block btn-lg btn-danger ",
    staticStyle: {
      "height": "42px",
      "width": "42px",
      "padding": "9px",
      "font-weight": "bold",
      "border-radius": "50%"
    },
    on: {
      "click": function($event) {
        return _vm.init()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-redo pull-left",
    staticStyle: {
      "margin": "2px -20px 0px 0px"
    }
  })])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-lg pull-right btn-default",
    staticStyle: {
      "height": "40px",
      "width": "40px",
      "padding": "9px",
      "font-weight": "bold",
      "border-radius": "50%",
      "background-color": "#000",
      "border": "none",
      "color": "#fff"
    },
    on: {
      "click": function($event) {
        return _vm.gotoInfo()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-info-circle pull-left",
    staticStyle: {
      "margin": "2px 5px 0px 0px"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col col-sm-2 pull-right"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-81f5c9da!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BinManager.vue
// module id = 533
// module chunks = 2